import { useFetch } from './useFetch'
import { useArquivoService } from './useArquivoService'
import { toPng } from 'html-to-image'

export const useExameNecrodontoscopicoService = () => {
  const fetch = useFetch()
  const arquivoService = useArquivoService()

  const listarExameNecrodontoscopicoDadosFormulario = async (id) => {
    try {
      const response = await fetch.get(`/exameNecrodontoscopico/dadosFormulario/${id}`)
      return response.data.exameNecrodontoscopico
    } catch (err) {
      return
    }
  }

  const editarExameNecrodontoscopico = async (id, dados) => {
    try {
      await fetch.putOpen(`/exameNecrodontoscopico/${id}`, dados)
    } catch (err) {
      return
    }
  }

  const setarSVGSExameNecrodonto = async (idExame, marcas) => {
    try {
      const responseSVGMarcasFront = await arquivoService.uploadSVGCalunga(marcas.svgFront, 'svg_marcas_front')
      const responseSVGMarcasBack = await arquivoService.uploadSVGCalunga(marcas.svgBack, 'svg_marcas_back')
      const responseSVGMarcasLeft = await arquivoService.uploadSVGCalunga(marcas.svgLeft, 'svg_marcas_left')
      const responseSVGMarcasRight = await arquivoService.uploadSVGCalunga(marcas.svgRight, 'svg_marcas_right')

      const dados = {
        id_svg_marcas_front: responseSVGMarcasFront.data.location,
        id_svg_marcas_back: responseSVGMarcasBack.data.location,
        id_svg_marcas_left: responseSVGMarcasLeft.data.location,
        id_svg_marcas_right: responseSVGMarcasRight.data.location,
      }

      await fetch.putOpen(`exameNecrodontoscopico/${idExame}`, dados)
    } catch (err) {
      return
    }
  }

  const setarImagemMapaOdonto = async (idExame, htmlMapa) => {
    if (!htmlMapa) return

    const originalHeight = htmlMapa.style.height
    const originalOverflow = htmlMapa.style.overflow

    htmlMapa.style.height = 'auto'
    htmlMapa.style.overflow = 'visible'

    const { scrollWidth, scrollHeight } = htmlMapa

    const dataUrl = await toPng(htmlMapa, {
      cacheBust: true,
      pixelRatio: 2,
      backgroundColor: '#fff',
      skipFonts: true,
      width: scrollWidth,
      height: scrollHeight,
      style: {
        margin: '0',
      },
    })

    htmlMapa.style.height = originalHeight
    htmlMapa.style.overflow = originalOverflow
    const response = await arquivoService.uploadMapaOdonto(dataUrl, idExame)

    await fetch.putOpen(`exameNecrodontoscopico/${idExame}`, { id_svg_mapa_odontologico: response.data.location })
  }

  const listarDentes = async (idExame) => {
    try {
      const response = await fetch.get(`/exameNecrodontoscopico/dentes/todos/${idExame}`)
      return response.data.dentes
    } catch (err) {
      console.log(err)
      return
    }
  }

  const cadastrarDentes = async (idExame, dentes) => {
    try {
      await fetch.postOpen(`exameNecrodontoscopico/cadastrar/dentes/${idExame}`, dentes)
    } catch (err) {
      console.log(err)
      return
    }
  }

  const editarDentes = async (dentes) => {
    try {
      await fetch.putOpen(`exameNecrodontoscopico/update/dentes`, dentes)
    } catch (err) {
      console.log(err)
      return
    }
  }

  return {
    listarExameNecrodontoscopicoDadosFormulario,
    editarExameNecrodontoscopico,
    setarSVGSExameNecrodonto,
    listarDentes,
    cadastrarDentes,
    editarDentes,
    setarImagemMapaOdonto,
  }
}
